import React, { useState, useEffect } from "react";
import Control from "../../common/Control";
import useStore from "../../../context/useStore";
import Loader from "../../common/Loader";
import Axios from "axios";
import { api_url } from "../../../config";
import { DateTime } from "luxon";
import { toast } from "react-toastify";
import CreateRdv from "./CreateRdv";

const initialDays = [
  { id: 1, name: "Lundi", morning: true, evening: false },
  { id: 2, name: "Mardi", morning: true, evening: false },
  { id: 3, name: "Mercredi", morning: true, evening: false },
  { id: 4, name: "Jeudi", morning: true, evening: false },
  { id: 5, name: "Vendredi", morning: true, evening: false },
  { id: 6, name: "Samedi", morning: true, evening: false },
];
const initialMoments = [
  { id: 1, name: "Matin" },
  { id: 2, name: "Après-midi" },
];

const FormRdv = ({ rdspId, userData, formData }) => {
  const [state, dispatch] = useStore();
  const constants = state.constants.items;
  const [organism, setOrganism] = useState(false);
  const [sites, setSites] = useState(false);
  const [rdvs, setRdvs] = useState(false);
  const [site, setSite] = useState(false);
  const [rdv, setRdv] = useState(false);
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [formRdv, setFormRdv] = useState(false);
  const [countSel, setCountSel] = useState(0);
  const [displayAllRdv, setDisplayAllRdv] = useState(false);
  const [timeSelected, setTimeSelected] = useState({
    days: [],
  });
  const [days, setDays] = useState(initialDays);
  const [rdvsLoading, setRdvsLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hasReturn, setHasReturn] = useState(false);

  useEffect(() => {
    Axios.get(api_url + "rdsp/" + rdspId + "/orientation")
      .then((res) => {
        setOrganism(res.data.organization);
        setSites(res.data.sites);
      })
      .catch((err) => {
        if (err.response && err.response.data) {
          setErrors(err.response.data);
        }
      })
      .then(() => {
        setIsLoading(false);
        setHasReturn(true);
      });
  }, []);
  useEffect(() => {
    if (site) {
      setRdv(false);
      setDisplayAllRdv(false);
      setRdvsLoading(true);
      Axios.post(api_url + "slotcalendars/sites/" + site, {
        userRecipientId: userData.id,
      })
        .then((res) => {
          setRdvs(res.data);
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            setErrors(err.response.data);
          }
        })
        .then(() => {
          setRdvsLoading(false);
        });
    }
  }, [site]);

  useEffect(() => {
    if (rdvs && rdvs.length > 0) {
      reCalcDays();
      setRdv(rdvs[0].id);
    }
  }, [rdvs]);

  useEffect(() => {
    if (countSel >= 3) {
      setRdv(false);
      setDisplayAllRdv(true);
    }
  }, [countSel]);

  useEffect(() => {
    setRdv(false);
  }, [timeSelected]);

  function reCalcDays() {
    var dys = JSON.parse(JSON.stringify(days));
    dys = dys.filter((d) => {
      if (
        rdvs.find((r) => {
          var daystart = DateTime.fromISO(r.start).weekday;
          if (daystart == d.id) {
            return true;
          }
        })
      ) {
        return d;
      }
    });
    setDays(dys);
  }

  function save() {
    if (Object.keys(errors).length === 0 && errors.constructor === Object) {
      var selRdv = rdvs.find((r) => r.id == rdv);
      selRdv.comment = message;
      setIsLoading(true);
      Axios.patch(api_url + "slotcalendars/recipients/" + userData.id, selRdv)
        .then((res) => {
          setFormRdv({
            rdv: selRdv,
            site: site,
          });
          toast.success("Votre RDV a bien été enregistré");
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            setErrors(err.response.data);
          }
        })
        .then(() => {
          setIsLoading(false);
        });
      //save
      // setFormRdv({
      //   site: 1,
      //   rdv: 2,
      // });
    }
  }
  function setNextRdv() {
    var currentIndex = null;
    rdvs.forEach((r, rk) => {
      if (r.id == rdv) {
        currentIndex = rk;
      }
    });
    if (currentIndex + Math.floor((rdvs.length - 1) / 2) > rdvs.length - 1) {
      currentIndex = 0;
    } else {
      currentIndex += Math.floor((rdvs.length - 1) / 2);
    }
    setRdv(rdvs[currentIndex].id);
    setCountSel(countSel + 1);
  }

  function updateTimeSelected(e) {
    var { name, value } = e.target;
    var ev = JSON.parse(JSON.stringify(timeSelected));

    if (ev[name].includes(value)) {
      ev[name] = ev[name].filter((v) => v != value);
    } else {
      ev[name].push(value);
    }

    setTimeSelected(ev);
  }

  return (!organism || isLoading) && !hasReturn ? (
    <Loader />
  ) : (
    <div className="row">
      <div className="col-12">
        {!formRdv ? (
          <section className="rdv-book">
            <h3 className="rdv-book__title">Prendre un rendez-vous</h3>
            <p className="rdv-book__subtitle">
              Accompagnement par <strong>{organism.name}</strong>
            </p>
            <div>
              {sites && (
                <Control
                  label="Choix du site du Rdv"
                  type="select"
                  name="site"
                  datas={sites}
                  dataIndex={"id"}
                  dataLabel={"name"}
                  value={site}
                  change={(e) => setSite(e.target.value)}
                  error={errors}
                />
              )}
              {rdvsLoading && <Loader />}
              {site &&
                rdvs &&
                (displayAllRdv ? (
                  <>
                    <Control
                      label="Quels jours de la semaine êtes-vous disponible ?"
                      type="checkBtnList"
                      btnInline={true}
                      name="days"
                      datas={days}
                      itemClassName={"btn-sm"}
                      value={timeSelected.days}
                      change={updateTimeSelected}
                    />

                    {timeSelected.days.length > 0 && (
                      <Control
                        label="Choix de la date de RDV"
                        type="btnList"
                        datas={rdvs.filter((r) => {
                          var timestart = DateTime.fromISO(r.start).weekday;
                          if (timeSelected.days.includes(timestart)) return true;
                          return false;
                        })}
                        dataIndex="id"
                        dataLabel="label"
                        name="rdv"
                        change={(e) => setRdv(e.target.value)}
                        value={rdv}
                      />
                    )}
                  </>
                ) : (
                  <>
                    {site && organism.slugName == "CAF_EG" && (
                      <>
                        <CreateRdv
                          site={sites.find((s) => s.id == site)}
                          recipientId={userData.id}
                        />
                        <div className="rdv-book__divider">ou</div>
                      </>
                    )}
                    {rdv && (
                      <div className="rdv-book__recap">
                        <h5 className="mb-2">Programmer un RDV</h5>
                        <div className="form-group mb-2">
                          <label className="d-block">Date de RDV proposée</label>
                          <button type="button" className="btn btn-default active">
                            {rdvs.find((r) => r.id == rdv).label}
                            <i className="fa fa-check ml-2" aria-hidden="true"></i>
                          </button>
                        </div>
                        <button type="button" className="btn btn-sm btn-ghost" onClick={setNextRdv}>
                          Choisir une autre date de RDV
                        </button>
                      </div>
                    )}
                  </>
                ))}
              {site && !rdvs.length && (
                <div className="alert alert-warning">
                  Aucun créneau de RDV disponible trouvé pour ce site.
                </div>
              )}
              {rdv && (
                <div className="mt-3">
                  <Control
                    label="Message pour la personne qui accueillera l'allocataire (facultatif)"
                    name="message"
                    value={message}
                    change={(e) => setMessage(e.target.value)}
                    error={errors}
                  />
                  {Object.keys(errors).length > 0 && (
                    <span className="text-danger" role="alert">
                      {Object.values(errors)}
                    </span>
                  )}
                  <button type="button" onClick={save} className="btn btn-success">
                    Valider ce rendez-vous {rdvs.find((r) => r.id == rdv).label}
                  </button>
                </div>
              )}
            </div>
          </section>
        ) : (
          <>
            <section className="rdv-book">
              <h3 className="rdv-book__title">Rendez-vous enregistré</h3>
              <div className="rdv-book__recap mt-3">
                <dl className="rdv-card__facts">
                  <div>
                    <dt>RDV fixé le</dt>
                    <dd>{formRdv.rdv.label}</dd>
                  </div>
                  <div>
                    <dt>Lieu du RDV</dt>
                    <dd>
                      {sites.find((s) => s.id == formRdv.site).name} -{" "}
                      {sites.find((s) => s.id == formRdv.site).address}{" "}
                      {sites.find((s) => s.id == formRdv.site).location.postalCode}{" "}
                      {sites.find((s) => s.id == formRdv.site).location.name}
                    </dd>
                  </div>
                </dl>
              </div>
            </section>
          </>
        )}
      </div>
      {errors.other && (
        <div className="col-12 mt-3">
          <p className="alert alert-danger">{errors.other}</p>
        </div>
      )}
    </div>
  );
};

export default FormRdv;
